import { useMutation, useQueryClient } from "@tanstack/react-query";

import { setFootprintingPigletFeedProduction, setFootprintingPigletFeedProductionAdmin } from "services";

import { footprintingPigletPrimaryQueryKeys, getEnvironment, invalidateAndRefecthQueries } from "utils";

import { FOOTPRINTING_PIGLET_FEED_PRODUCTION } from "consts";

import { PigletFeedProduction } from "models";

export const useMutateFootprintingPigletFeedProduction = (
  feedInformationId: string,
  primaryDataId: string,
  farmId: string,
  year: number,
  onSuccess?: () => void
) => {
  const isAdmin = getEnvironment().admin;
  const queryClient = useQueryClient();
  return useMutation(
    {
      mutationKey: [FOOTPRINTING_PIGLET_FEED_PRODUCTION, feedInformationId, isAdmin],
      mutationFn: (data: PigletFeedProduction) =>
        isAdmin ? setFootprintingPigletFeedProductionAdmin(feedInformationId, data) : setFootprintingPigletFeedProduction(feedInformationId, data),
      onSuccess: async () => {
        await invalidateAndRefecthQueries(queryClient, [
          [FOOTPRINTING_PIGLET_FEED_PRODUCTION, feedInformationId, isAdmin],
          ...footprintingPigletPrimaryQueryKeys(primaryDataId, farmId, year, isAdmin),
        ]);
        onSuccess?.();
      },
    },
    queryClient
  );
};
